import Vue from "vue";
import isCRMUser from "@util/isCRMUser";
import { lxBidTracker } from "@util/lxTracker";
import { getCookie } from '@util/cookie';

Vue.directive('authority', {
  inserted (el, binding, vnode) {
    let menuList = JSON.parse(localStorage.menuList);
    let menus = [];
    if (isCRMUser()) {
      menus = menuList.chain;
    } else {
      menus = menuList;
    }

    let flag = ~menus.indexOf(binding.value);
    if (!flag) {
      if (el.parentNode) {
        el.parentNode.removeChild(el);
      } else {
        el.innerHTML = '';
        el.style.display = 'none';
        // 解除组件的事件
        vnode.elm.__vue__ && vnode.elm.__vue__.$off();
        // 解除链接跳转
        el.tagName === 'A' && el.setAttribute('href', 'javascript:void(0)');
        // 解除元素点击事件
        if (vnode.data.on && vnode.data.on.click) {
          vnode.data.on.click.fn = () => {
            return;
          };
        }
        ;
        if (vnode.data.nativeOn && vnode.data.nativeOn.click) {
          vnode.data.nativeOn.click.fn = () => {
            return;
          };
        }
        ;
      }
    }
  }
});

const pendingBtns = {};
Vue.directive('multi-request', {
  bind: function (el, binding) {
    const btnText = el.innerHTML;
    el.onclick = (e) => {
      pendingBtns[e.currentTarget.id || 'saveBtn'] = {
        el: e.currentTarget,
        buttonText: e.currentTarget.innerHTML
      };
      e.currentTarget.innerHTML = '操作中';
      e.currentTarget.disabled = 'disabled';
      e.currentTarget.className += ' is-loading';
    };
  }
});

setTimeout(() => {
  Vue.prototype.$resetBtn = (id = 'saveBtn', options = {}) => {
    setTimeout(() => {
      const el = pendingBtns[id].el;
      el.innerHTML = pendingBtns[id].buttonText;
      el.disabled = '';
      el.className = el.className.replace('is-loading', '');
      delete pendingBtns[id];
    }, 300);
  };
}, 0);

function clickHandler (binding, cid) {
  return () => {
    binding.value.cid = cid;
    lxBidTracker(binding.value);
  };
}

Vue.directive('tracker', {
  bind (el, binding, vnode) {
    try {
      // Vue 自定义指令在 @click 绑定事件之后执行，缓存 cid 防止页面跳转后 cid 发生变化
      const route = vnode.context.$route.meta;
      const cid = route && route.cid ? route.cid : '';
      el.addEventListener('click', clickHandler(binding, cid));
    } catch (e) {
      console.log(e);
    }
  },
  unbind (el) {
    el.removeEventListener('click', clickHandler);
  }
});


// WEBPACK FOOTER //
// ./src/components/core/registerDirective.js